class AmpedApparelSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-apparel-slide]')];
    this.index = 0;
    this.controller = new AbortController();
    if (this.slides.length < 2) return;
    this.querySelector('[data-apparel-controls]').hidden = false;
    const options = { signal: this.controller.signal };
    this.querySelector('[data-apparel-prev]').addEventListener('click', () => this.show(this.index - 1), options);
    this.querySelector('[data-apparel-next]').addEventListener('click', () => this.show(this.index + 1), options);
  }

  show(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
    this.querySelector('[data-apparel-status]').textContent = this.dataset.statusTemplate
      .replace('__CURRENT__', String(this.index + 1)).replace('__TOTAL__', String(this.slides.length));
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('amped-apparel-slider')) customElements.define('amped-apparel-slider', AmpedApparelSlider);
